import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { RequisitoRespaldo } from '../_models/requisito-respaldo';
import {RequisitoRespaldoTipoVinculacion} from '../_models/requisito-respaldo-tipo-vinculacion';

@Injectable({
  providedIn: 'root'
})
export class RequisitosRespaldosTipoVincuracionService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/requisitosGarantiasRespaldosTiposVinculaciones';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as RequisitoRespaldoTipoVinculacion[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as
      RequisitoRespaldoTipoVinculacion[] ) );
  }

  listadoHabilitadosPorUnidadCredito( idSolUc: string ) {
    return this.httClient.get( this.rutServicio + '/solicitudUnidadCredito/' + idSolUc ).pipe( map( res => res as RequisitoRespaldoTipoVinculacion[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as RequisitoRespaldoTipoVinculacion ) );
  }

  obtenerPorIdRequisito( id: string ) {
    return this.httClient.get( this.rutServicio + '/requisitoGarantiaRespaldo/' + id ).pipe( map( res => res as RequisitoRespaldoTipoVinculacion[] ) );
  }

  listadoPorIdRequisitoHabilitado( id: string ) {
    return this.httClient.get( this.rutServicio + '/requisitoGarantiaRespaldo/' + id + '/enabled' ).pipe( map( res => res as RequisitoRespaldoTipoVinculacion[] ) );
  }

  crear( regCrear: RequisitoRespaldoTipoVinculacion ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as RequisitoRespaldoTipoVinculacion ) );
  }

  bulk( regCrear: RequisitoRespaldoTipoVinculacion[] ) {
    const auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    regCrear.map( x => {
      x.auditoriaUsuario = auditoriaUsuario;
    } );
    return this.httClient.post( this.rutServicio + '/bulk', regCrear ).pipe( map( res => res as RequisitoRespaldoTipoVinculacion ) );
  }

  actualizar( regActualizar: RequisitoRespaldoTipoVinculacion ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }
}
